import React from 'react'
import PropTypes from 'prop-types'
import K8ProgramPreferencesSetupView from './component'

const K8ProgramPreferencesSetupViewContainer = ({
  buttonLabel,
  ftueData,
  header,
  navigationEvent,
  onReadyClick,
}) => {
  const handleReadyClick = () => {
    // If onReadyClick prop is provided, use it (for modal opening, etc.)
    if (onReadyClick) {
      onReadyClick()
    }

    // Handle navigation or action when the "I'm Ready!" button is clicked
    // This is a placeholder - implement the actual navigation or action as needed
    if (navigationEvent) {
      // Example: Navigate to preferences setup page
      // navigationEvent('/path/to/preferences/setup', 'OPEN')
    }
  }

  return (
    <K8ProgramPreferencesSetupView
      buttonLabel={buttonLabel}
      ftueData={ftueData}
      header={header}
      onReadyClick={handleReadyClick}
    />
  )
}

K8ProgramPreferencesSetupViewContainer.propTypes = {
  buttonLabel: PropTypes.string,
  ftueData: PropTypes.object,
  header: PropTypes.string,
  navigationEvent: PropTypes.func,
  onReadyClick: PropTypes.func,
}

export default K8ProgramPreferencesSetupViewContainer
